export interface Route {
    path: string;
    name: string;
    title: string;
    load: () => any;
    props?: any;
    canGoBack: boolean;
    authMode: AuthMode;
}
export interface AppBarRoute extends Route {
    showAppBar: true;
}
export interface FallbackRoute {
    default: true;
    title: string;
    name: string;
    load: () => any;
    path: undefined;
    props?: any;
    canGoBack: boolean;
    showAppBar: boolean;
    authMode: 'public';
}

export function hasAppBar(route: SomeRoute): route is AppBarRoute {
    return !!(route as AppBarRoute).showAppBar;
}

export type SomeRoute = Route | AppBarRoute | FallbackRoute;

export function isNotFallbackRoute(route: SomeRoute): route is Route | AppBarRoute {
    return route.path !== undefined;
}

type AuthMode = 'public' | 'private' | 'exclusivelyPublic';

const routeSettings: SomeRoute[] = [
    {
        path: '/',
        name: 'projects',
        title: 'Projects',
        load: () => import('../views/Projects'),
        showAppBar: true,
        canGoBack: false,
        authMode: 'private',
    },
    {
        name: 'project',
        title: 'Project',
        path: '/projects/:projectId/',
        load: () => import('../views/Patients'),
        props: {
            canAddPatient: true,
            canNavigateToPatient: true,
        },
        showAppBar: true,
        canGoBack: true,
        authMode: 'private',
    },
    {
        name: 'patient',
        title: 'Patient',
        path: '/projects/:projectId/patients/:patientId/',
        load: () => import('../views/Patient'),
        showAppBar: true,
        canGoBack: true,
        authMode: 'private',
    },
    {
        name: 'createPatient',
        title: 'Create Patient',
        path: '/projects/:projectId/patients/create/',
        load: () => import('../views/CreatePatient'),
        showAppBar: true,
        canGoBack: true,
        authMode: 'private',
    },
    {
        name: 'hospitals',
        title: 'Hospitals',
        path: '/hospitals/',
        load: () => import('../views/Hospitals'),
        showAppBar: true,
        canGoBack: false,
        authMode: 'private',
    },
    {
        name: 'patients',
        title: 'Patients',
        path: '/patients/',
        load: () => import('../views/Patients'),
        props: {
            canAddPatient: false,
            canNavigateToPatient: false,
        },
        showAppBar: true,
        canGoBack: false,
        authMode: 'private',
    },
    {
        name: 'form',
        title: 'Form',
        path: '/projects/:projectId/patients/:patientId/forms/:formId/',
        load: () => import('../views/Form'),
        showAppBar: true,
        canGoBack: true,
        authMode: 'private',
    },
    {
        name: 'login',
        title: 'Login',
        path: '/login/',
        load: () => import('../views/Login'),
        canGoBack: false,
        authMode: 'exclusivelyPublic',
    },
    {
        name: 'forgotPassword',
        title: 'Forgot Password',
        path: '/forgot-password/',
        load: () => import('../views/ForgotPassword'),
        canGoBack: false,
        authMode: 'exclusivelyPublic',
    },

    {
        name: 'fourHundredThree',
        title: '403',
        path: '/403/',
        load: () => import('../views/FourHundredThree'),
        showAppBar: true,
        canGoBack: true,
        authMode: 'public',
    },
    {
        name: 'fourHundredFour',
        title: '404',
        load: () => import('../views/FourHundredFour'),
        default: true,
        path: undefined,
        showAppBar: true,
        canGoBack: true,
        authMode: 'public',
    },
];

export default routeSettings;
